module.exports = __webpack_public_path__ + "static/media/contact us.6f9cea95.jpg";